import { Container } from "react-bootstrap";

function PoliticasReembolso() {
  return (
    <Container className="mt-5 mb-5">
      {/* Señal de carga completa para el pre-renderizador (para páginas estáticas) */}
      <div id="snap-ready" style={{ display: "none" }}></div>

      <h1 className="mb-4">Políticas de Reembolso y Devolución</h1>

      <h4>1. Plazo de devolución</h4>
      <p>
        Nuestra política tiene una duración de 30 días. Si han pasado 30 días
        desde su compra, desafortunadamente no podemos ofrecerle un reembolso o
        cambio.
      </p>

      <h4>2. Condiciones para la devolución</h4>
      <p>
        Para ser elegible para una devolución, su artículo debe estar sin usar y
        en las mismas condiciones en que lo recibió. También debe estar en su
        embalaje original.
      </p>

      <h4>3. Productos no retornables</h4>
      <p>
        Varios tipos de bienes están exentos de ser devueltos, como productos
        perecederos (alimentos, flores), productos íntimos o sanitarios, y
        tarjetas de regalo.
      </p>

      <h4>4. Proceso de reembolso</h4>
      <p>
        Una vez que su devolución es recibida e inspeccionada, le enviaremos un
        mensaje para notificarle que hemos recibido su artículo devuelto.
        También le notificaremos la aprobación o rechazo de su reembolso. Si es
        aprobado, su reembolso será procesado a través del método de pago
        original o transferencia bancaria.
      </p>

      <h4>5. Envío</h4>
      <p>
        Usted será responsable de pagar sus propios costos de envío para
        devolver su artículo, a menos que el motivo de la devolución sea un
        error nuestro o un producto defectuoso.
      </p>
    </Container>
  );
}

export default PoliticasReembolso;
